/**
 * Error types for token refresh operations
 */
export class TokenRefreshError extends Error {
	constructor(
		message: string,
		public readonly type: 'NETWORK_ERROR' | 'INVALID_TOKEN' | 'EXPIRED_REFRESH_TOKEN' | 'UNKNOWN_ERROR',
		public readonly shouldSignOut: boolean,
		public readonly originalError?: Error,
	) {
		super(message);
		this.name = 'TokenRefreshError';
	}
}

export class AuthenticationError extends Error {
	constructor(
		message: string,
		public readonly originalError?: Error,
		public readonly type?: string,
	) {
		super(message);
		this.name = 'AuthenticationError';
	}
}

export class InvitationError extends Error {
	constructor(
		message: string,
		public readonly originalError?: Error,
	) {
		super(message);
		this.name = 'InvitationError';
	}
}

export type TwoFactorCodeErrorType = 'INVALID_CODE' | 'TOO_MANY_ATTEMPTS' | 'EXPIRED' | 'UNKNOWN';

/** A rejected two-factor code. `type` tells the UI what to say. */
export class TwoFactorCodeError extends Error {
	constructor(
		public readonly type: TwoFactorCodeErrorType,
		public readonly originalError?: unknown,
	) {
		super(`Two-factor code rejected: ${type}`);
		this.name = 'TwoFactorCodeError';
	}

	static fromResponse(error: unknown): TwoFactorCodeError {
		const response = (error as { response?: { status?: number; data?: { message?: string } } } | undefined)?.response;
		const message = response?.data?.message;
		if (message === 'auth.two.factor.too.many.attempts') {
			return new TwoFactorCodeError('TOO_MANY_ATTEMPTS', error);
		}
		if (message === 'auth.two.factor.invalid.code' || message === 'auth.two.factor.code.required') {
			return new TwoFactorCodeError('INVALID_CODE', error);
		}
		if (response?.status === 401) {
			return new TwoFactorCodeError('EXPIRED', error);
		}
		return new TwoFactorCodeError('UNKNOWN', error);
	}
}
